import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import firebase from '../tools/firebase';

const ProtectedRoute = ({ component: Component, ...rest }) => {
    const [authState, setAuthState] = useState({ loading: true, user: null });

    useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged(user => {
            setAuthState({ loading: false, user });
        });
        return unsubscribe;
    }, []);

    return (
        <Route
            {...rest}
            render={props => {
                if (authState.loading) return null;
                return authState.user
                    ? <Component {...props} />
                    : <Redirect to="/admin" />;
            }}
        />
    );
};

export default ProtectedRoute;
